import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import SweetAlert from "react-bootstrap-sweetalert";
import { defaultDiacriticsRemovalMap } from "../../helpers/ascii_helper";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import filterFactory from "react-bootstrap-table2-filter";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  FormGroup,
  Alert,
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import PageLoader from "../../components/Loaders/pageLoader";
import tronko from "../../assets/images/tronko.jpg";
import footer_tronko from "../../assets/images/footer_tronko.jpg";
import BtnLoader from "../../components/Loaders/btnLoader";
//PDF
import {
  getActShippings,
  addActShipping,
  updateActShipping,
  deleteActShipping,
} from "../../store/actShipping/actions";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  currentDate,
  year,
  month,
  months,
} from "../../helpers/current_date_helper";
//Import Breadcrumb
import MyExportCSV from "../../components/exportCSV";
import Breadcrumbs from "../../components/Breadcrumb";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { getScreenHeight } from "../../helpers/screen_height_helper";

class ActShippingList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actShipping: [],
      my_filtered_shippings: [],
      filteredMonth: month.toString(),
      filteredYear: year,
      displayHidden: false,
      selectedRows: [],
      selectedRowsPDF: [],
      correctDate: true,
      modalNewActShipping: false,
      isEdit: false,
      alert: null,
      error: "",
      orderDate: "",
      quantity: 0,
      brochures: 0,
      ActShippingListColumns: [
        {
          text: "ID",
          dataField: "_id",
          sort: true,
          editable: false,
          csvExport: false,
          formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
          text: "Date Added",
          dataField: "createdAt",
          sort: true,
          csvExport: true,
          hidden: false,
          editable: false,
          csvFormatter: (cell, row, rowIndex) =>
            row.date != null && new Date(row.date).toLocaleDateString("en-GB"),
          formatter: (cell, actShipping) => {
            let dateObj = actShipping.date;
            if (typeof cell !== "object") {
              dateObj = new Date(cell);
            }
            return (
              dateObj &&
              `${("0" + dateObj.getDate()).slice(-2)}/${("0" + (dateObj.getMonth() + 1)).slice(-2)}/${dateObj.getFullYear()} ${dateObj.getHours()}:${dateObj.getMinutes()}`
            );
          },
          editor: {
            type: Type.DATE,
          },
        },
        {
          text: "Tracking No",
          dataField: "trackingNo",
          sort: true,
          editable: true,
          csvFormatter: (cell, row, rowIndex) =>
            parseInt(row.trackingNo).toFixed(0),
          formatter: (cellContent, actShipping) => (
            <h5 className="font-size-16 mb-1">{actShipping.trackingNo}</h5>
          ),
        },
        {
          text: "Shipping Date",
          dataField: "shipDate",
          sort: true,
          csvExport: true,
          hidden: false,
          // editable: true,
          csvFormatter: (cell, row, rowIndex) =>
            row.shipDate != null &&
            new Date(row.shipDate).toLocaleDateString("en-GB"),
          formatter: (cell, actShipping) => {
            if (actShipping.shipDate !== null) {
              let dateObj = actShipping.shipDate;
              if (typeof cell !== "object") {
                dateObj = new Date(cell);
              }
              return (
                dateObj &&
                `${("0" + dateObj.getDate()).slice(-2)}/${("0" + (dateObj.getMonth() + 1)).slice(-2)}/${dateObj.getFullYear()}`
              );
            } else {
              return "";
            }
          },
          editor: {
            type: Type.DATE,
          },
        },
        {
          text: "Invoice",
          dataField: "invoiceNo",
          sort: true,
          editable: false,
          csvText: "Invoice Number",
          formatter: (cellContent, actShipping) => (
            <h5 className="font-size-16 mb-1 text-center">
              {actShipping.invoiceNo}
            </h5>
          ),
        },
        {
          text: "Quantity",
          dataField: "quantity",
          sort: true,
          editable: false,
          formatter: (cellContent, actShipping) => (
            <h5 className="font-size-16 mb-1 text-center">
              {actShipping.quantity}
            </h5>
          ),
        },
        {
          text: "Brochures",
          dataField: "brochures",
          sort: true,
          editable: true,
          formatter: (cellContent, actShipping) => (
            <h5 className="font-size-16 mb-1 text-center">
              {actShipping.brochures}
            </h5>
          ),
        },
        {
          text: "Comments",
          dataField: "comments",
          sort: true,
          editable: true,
          formatter: (cellContent, actShipping) => (
            <h5 className="font-size-16 mb-1 text-center">
              {actShipping.comments}
            </h5>
          ),
        },
        {
          text: "Country",
          dataField: "country",
          sort: true,
          editable: false,
          formatter: (cellContent, actShipping) => (
            <h5 className="font-size-16 mb-1 text-center">
              {actShipping.country}
            </h5>
          ),
        },
        {
          text: "City",
          dataField: "city",
          sort: true,
          editable: false,
          formatter: (cellContent, actShipping) => (
            <h5 className="font-size-16 mb-1 text-center">
              {actShipping.city}
            </h5>
          ),
        },
        {
          text: "Region",
          dataField: "region",
          sort: true,
          editable: false,
          formatter: (cellContent, actShipping) => (
            <h5 className="font-size-16 mb-1 text-center">
              {actShipping.region}
            </h5>
          ),
        },
        {
          text: "Address",
          dataField: "address",
          sort: true,
          editable: false,
          formatter: (cellContent, actShipping) => (
            <div className="text-break name-width">
              <h5 className="font-size-16 mb-1 text-center">
                {actShipping.address}
              </h5>
            </div>
          ),
        },
        {
          text: "Full Name",
          dataField: "name",
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, actShipping) => (
            <div className="name-width">
              <h5 className="font-size-16 mb-1 text-lowercase text-center">
                {this.removeDiacritics(actShipping.name)}
              </h5>
            </div>
          ),
        },
        {
          text: "Phone #",
          dataField: "phone",
          sort: true,
          formatter: (cellContent, user) => (
            <>
              <h5 className="font-size-16 mb-1 text-center">{user.phone}</h5>
            </>
          ),
        },

        {
          dataField: "menu",
          //   isDummyField: true,
          text: "Action",
          editable: false,
          csvExport: false,
          formatter: (cellContent, actShipping) => (
            <div className='d-flex gap-3'>
              {this.props.profileData.permissions.includes('actShippingAccess') && (
                <>
                  <Link className="text-success" to="#">
                    <i
                      className="mdi mdi-pencil font-size-18"
                      id="edittooltip"
                      onClick={(e) =>
                        this.handleEditActShippingClick(e, actShipping, "edit")
                      }
                    ></i>
                  </Link>
                  <Link className="text-danger" to="#">
                    <i
                      className="mdi mdi-delete font-size-18"
                      id="deletetooltip"
                      onClick={() => this.handleDeleteActShipping(actShipping)}
                    ></i>
                  </Link>
                </>
              )}
              <Link className="text-primary" to="#">
                <i
                  className={
                    actShipping.status
                      ? "mdi mdi-lock font-size-18"
                      : "mdi mdi-lock-open-outline font-size-18"
                  }
                  onClick={(e) =>
                    this.handleEditActShippingClick(e, actShipping, "locked")
                  }
                ></i>
              </Link>
            </div>
          ),
        },
      ],
    };
    // this.getScreenHeight = this.getScreenHeight.bind(this);
    this.indication = this.indication.bind(this);
    this.removeDiacritics = this.removeDiacritics.bind(this);
    this.rowClasses = this.rowClasses.bind(this);
    this.afterSaveCell = this.afterSaveCell.bind(this);
    this.handleNewActShippingClick = this.handleNewActShippingClick.bind(this);
    this.toggleNewActShippingModal = this.toggleNewActShippingModal.bind(this);
    this.handleNewActShippingSubmit =
      this.handleNewActShippingSubmit.bind(this);
    this.handleEditActShippingClick =
      this.handleEditActShippingClick.bind(this);
    this.handleDeleteActShipping = this.handleDeleteActShipping.bind(this);
    this.handleExportPDF = this.handleExportPDF.bind(this);
    this.handleFilterDataSubmit = this.handleFilterDataSubmit.bind(this);
    this.handleFormReset = this.handleFormReset.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.getDate = this.getDate.bind(this);
    // this.resetFilterData = this.resetFilterData.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleDateCopy = this.handleDateCopy.bind(this);
  }
  componentDidMount() {
    const { onGetActShipping } = this.props;
    onGetActShipping();
    window.addEventListener("load", getScreenHeight);
    window.addEventListener("click", getScreenHeight, { once: true });
    window.addEventListener("resize", getScreenHeight);
  }
  componentWillUnmount() {
    window.removeEventListener("load", getScreenHeight);
    window.removeEventListener("click", getScreenHeight);
    window.removeEventListener("resize", getScreenHeight);
  }

  // getScreenHeight = () => {
  //   if (document.getElementById('card-section') != null) {
  //     let screenHeight = document.getElementById('card-section').offsetHeight;
  //     document.querySelector('.react-bootstrap-table').setAttribute('style', 'height: calc(' + screenHeight + 'px - 100px); overflow: auto;');
  //   }
  // };

  afterSaveCell = (oldValue, newValue, row, column, rowId) => {
    const { onUpdateActShipping } = this.props;
    setTimeout(() => {
      row[column.dataField] = newValue;
      if (column.text === "Tracking No") {
        row["shipDate"] = currentDate;
      }
      onUpdateActShipping(row);

      const result = this.state.ActShippingListColumns.map((row_map) => {
        if (row_map.id === rowId) {
          const newRow = { ...row_map };
          newRow[column.dataField] = newValue;
          return newRow;
        }
        return row_map;
      });
      this.setState({ ActShippingListColumns: result });
      // }
    }, 100);
    return { newValue, async: true };
  };

  indication = () => {
    let emptyMessage = "";
    if (this.props.actShippings.length !== 0) {
      emptyMessage = `No Results Found`;
    }
    return emptyMessage;
  };

  rowClasses = (row, rowIndex) => {
    let classes = null;
    if (row.shipDate && row.trackingNo !== "") {
      classes = "completed-row";
    }
    if (row.status === true) {
      classes = "on-hold-row";
    }
    return classes;
  };

  removeDiacritics = (str) => {
    let changes = "";
    if (!changes) {
      changes = defaultDiacriticsRemovalMap;
    }
    for (var i = 0; i < changes.length; i++) {
      str = str.replace(changes[i].letters, changes[i].base);
    }
    return str;
  };

  toggleNewActShippingModal = () => {
    this.setState((prevState) => ({
      modalNewActShipping: !prevState.modalNewActShipping,
    }));
  };

  handleDateCopy = (e) => {
    const { value } = e.target;
    this.setState((prevState) => ({ ...prevState, quantity: value }));
    this.setState((prevState) => ({ ...prevState, brochures: value }));
  };

  handleNewActShippingClick = () => {
    this.setState({ actShipping: [], error: "", isEdit: false });
    this.toggleNewActShippingModal();
  };

  handleNewActShippingSubmit = (e, values) => {
    const { onAddActShipping, onUpdateActShipping } = this.props;
    const { isEdit, actShipping } = this.state;
    if (isEdit) {
      const updateActShipping = {
        _id: actShipping._id,
        invoiceNo: values.invoiceNo,
        quantity: values.quantity,
        brochures: values.brochures,
        comments: values.comments,
        country: values.country,
        city: values.city,
        region: values.region,
        address: values.address,
        name: values.name,
        phone: values.phone,
        month: values.month,
        year: values.year,
      };
      // updated order
      onUpdateActShipping(updateActShipping);
    } else {
      const newActShipping = {
        date: "",
        trackingNo: "",
        shipDate: "",
        invoiceNo: values["invoiceNo"],
        quantity: values["quantity"],
        brochures: values["brochures"],
        comments: values["comments"],
        country: values["country"],
        city: values["city"],
        region: values["region"],
        address: values["address"],
        name: values["name"],
        phone: values["phone"],
        month: values["month"],
        year: values["year"],
        status: false,
      };
      onAddActShipping(newActShipping);
    }
    this.toggleNewActShippingModal();
  };

  handleEditActShippingClick = (e, actShipping, type) => {
    const { onUpdateActShipping } = this.props;
    this.setState({
      actShipping: {
        _id: actShipping._id,
        trackingNo: actShipping.trackingNo,
        invoiceNo: actShipping.invoiceNo,
        quantity: actShipping.quantity,
        brochures: actShipping.brochures,
        comments: actShipping.comments,
        country: actShipping.country,
        city: actShipping.city,
        region: actShipping.region,
        address: actShipping.address,
        name: actShipping.name,
        phone: actShipping.phone,
        month: actShipping.month,
        year: actShipping.year,
      },
      isEdit: true,
      error: "",
    });

    if (type === "edit") {
      this.toggleNewActShippingModal();
    }
    if (type === "locked") {
      const updatedActShipping = {
        _id: actShipping._id,
        status: actShipping.status === false ? true : false,
      };
      onUpdateActShipping(updatedActShipping);
    }
  };

  handleDeleteActShipping = (actShipping) => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText="Yes, delete it!"
        confirmBtnBsStyle="danger"
        title="Are you sure?"
        onConfirm={() => this.deleteAlert(actShipping._id)}
        onCancel={this.hideAlert}
        focusCancelBtn
      ></SweetAlert>
    );

    this.setState({
      alert: getAlert(),
    });
  };

  handleFilterDataSubmit = (e, values) => {
    const { actShippings } = this.props;
    let my_filtered_shippings = [];

    actShippings.map((act) => {
      if (
        values &&
        act.month === parseInt(values.month) &&
        act.year === parseInt(values.year)
      ) {
        my_filtered_shippings.push(act);
      } else if (
        !values &&
        act.month === parseInt(month) &&
        act.year === parseInt(year)
      ) {
        my_filtered_shippings.push(act);
      }
      return my_filtered_shippings;
    });
    this.setState({ my_filtered_shippings });
  };

  // resetFilterData = (e) => {
  //   e.preventDefault();
  //   window.location.reload();
  // };
  handleFormReset = () => {
    // Set the default values for month and year fields
    this.setState({
      filteredMonth: month.toString(), // Replace defaultValueForMonth with your desired default value for the month field
      filteredYear: year, // Replace defaultValueForYear with your desired default value for the year field
    });
  };

  handleFilterChange = (e) => this.setState({ filteredMonth: e.target.value });

  deleteAlert = (id) => {
    const { onDeleteActShipping } = this.props;
    onDeleteActShipping(id);
    this.hideAlert();
  };

  handleExportPDF = () => {
    const { ActShippingListColumns, selectedRowsPDF } = this.state;
    let headerData = [];
    let bodyData = [];

    selectedRowsPDF.forEach((el) => {
      bodyData.push([
        el.invoiceNo,
        el.quantity,
        el.brochures,
        el.country,
        el.city,
        el.region,
        el.address,
        el.name,
        el.phone,
      ]);
    });

    ActShippingListColumns.slice(4, -1).map((head, i) => {
      headerData.push(head.text);
    });

    var doc = new jsPDF({ orientation: "l", unit: "pt" });
    doc.setFont(undefined, "normal");

    let rowsPerPage = 1;
    let currentPage = 1;

    //Width of columns
    var columnStyles = {
      3: { halign: "center" },
    };
    // Loop through each row
    bodyData.forEach(function (row, index) {
      // Check if the current row exceeds the rows per page limit
      if (index > 0 && index % rowsPerPage === 0) {
        // Add a new page
        doc.addPage();
        currentPage++;
      }

      // Define the table headers and body
      var body = [row];

      // Add the table to the current page using autoTable plugin
      doc.autoTable({
        head: [headerData], // don't forget square brackets, columns is an array of string
        body: body, // array of arrays of string
        startY: 150,
        margin: { horizontal: 10 },
        styles: {
          fontSize: 14, // Set the font size
          cellHeight: 30,
          cellWidth: "wrap", // Adjust the cell width to fit the content
          valign: "middle", // Vertically center the content within the cell
          halign: "center", // Horizontally center the content within the cell
          // lineColor: [0, 0, 0]
        },
        headStyles: { fillColor: [155, 89, 182] },
        bodyStyles: { valign: "top" },
        columnStyles: columnStyles,
        autoSize: true,
        theme: "grid",
        showHead: "everyPage",
        // didDrawCell: function (data) {
        //   if (data.row.index === 0) {
        //     data.cell.styles.fillColor = [255, 255, 255]; // Set the background color of header cells to white
        //   }
        // },
        didDrawPage: function (data) {
          // Header
          doc.setTextColor(40);
          doc.addImage(tronko, "JPEG", data.settings.margin.left, 15, 820, 110);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          let pageSize = doc.internal.pageSize;
          let pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          doc.addImage(
            footer_tronko,
            "JPEG",
            data.settings.margin.left,
            pageHeight - 100,
            450,
            100,
          );
        },
      });
    });

    doc.save("Tronko_Actividan.pdf");
  };

  hideAlert = () => this.setState({ alert: null });

  getDate = (array, field) => {
    return [...new Set(array.map((obj) => obj[field]))];
  };

  render() {
    const { SearchBar } = Search;
    const { actShippings, profileData, loading } = this.props;
    const {
      isEdit,
      error,
      correctDate,
      actShipping,
      selectedRows,
      selectedRowsPDF,
      my_filtered_shippings,
      filteredYear,
      filteredMonth,
    } = this.state;
    const pageOptions = {
      sizePerPage: actShippings.length,
      sizePerPageList: [500, 1000, 1500],
      totalSize: actShippings.length,
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: "date", // if dataField is not match to any column you defined, it will be ignored.
        order: "asc", // desc or asc
      },
    ];

    const selectRow = {
      mode: "checkbox",
      selected: selectedRows,
      multipleSelectRow: true,
      onSelectAll: (isSelect, rows, e) => {
        if (!isSelect) {
          this.setState({ selectedRows: [], selectedRowsPDF: [] });
        } else {
          let selectedRowsPDF = [];
          rows.map((row, i) => {
            selectedRows.push(row._id);
            selectedRowsPDF.push(row);
            this.setState({
              selectedRows: selectedRows,
              selectedRowsPDF: selectedRowsPDF,
            });
          });
        }
      },
      onSelect: (row, isSelect, rowIndex, e) => {
        if (e.shiftKey) {
          const lastSelectedIndex = this.state.lastSelectedIndex;
          const currentRowIndex = rowIndex;
          const start = Math.min(lastSelectedIndex, currentRowIndex);
          const end = Math.max(lastSelectedIndex, currentRowIndex);
          const newSelectedRows = Array.from(
            { length: end - start + 1 },
            (_, index) => this.state.selectedRowsPDF[start + index]?.id,
          );
          const newSelectedRowsPDF = newSelectedRows.map(
            (index) => this.state.selectedRowsPDF[index],
          );
          this.setState({
            selectedRows: newSelectedRows.map(
              (index) => this.state.selectedRows[index]._id,
            ),
            selectedRowsPDF: newSelectedRowsPDF,
          });
        } else {
          const selectedRowIds = isSelect
            ? [...this.state.selectedRows, row._id]
            : this.state.selectedRows.filter((id) => id !== row._id);

          const selectedRowsPDF = isSelect
            ? [...this.state.selectedRowsPDF, row]
            : this.state.selectedRowsPDF.filter((item) => item._id !== row._id);

          this.setState({
            selectedRows: selectedRowIds,
            selectedRowsPDF: selectedRowsPDF,
            lastSelectedIndex: rowIndex,
          });
        }
      },
    };

    return (
      <React.Fragment>
        {/* {profileData.length === 0 && loading && <PageLoader />} */}
        {profileData.length !== 0 && (
          <PageLoader
            progress={!loading && { step: "Completed", time: 100 }}
            isLoading={loading}
          />
        )}
        <div className="page-content">
          <MetaTags>
            <title>Actividan Shipping</title>
          </MetaTags>
          <Container fluid>
            {profileData.permissions.includes('actShippingAccess') ? (
              <>
                {/* Render Breadcrumbs */}
                <Breadcrumbs
                  title="Korupharma"
                  breadcrumbItem="Actividan Shipping"
                />
                <Row id="card-section" onLoad={getScreenHeight()}>
                  <Col lg="12">
                    <Card>
                      <CardBody className="cardBodySticky">
                        <PaginationProvider
                          pagination={paginationFactory(pageOptions)}
                          keyField="_id"
                          columns={this.state.ActShippingListColumns}
                          data={
                            my_filtered_shippings.length !== 0
                              ? my_filtered_shippings
                              : actShippings.filter((el) => {
                                  return el.month === month;
                                })
                          }
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider
                              keyField="_id"
                              columns={this.state.ActShippingListColumns}
                              data={
                                my_filtered_shippings.length !== 0
                                  ? my_filtered_shippings
                                  : actShippings.filter((el) => {
                                      return el.month === month;
                                    })
                              }
                              search
                              exportCSV={{
                                fileName: "Actividan.xls",
                                blobType:
                                  "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                              }}
                            >
                              {(toolkitprops) => (
                                <React.Fragment>
                                  <Row className="mb-2">
                                    <Col md="2" sm="12" className="d-flex">
                                      <div className="search-box ms-2 mb-2 me-5 d-inline-block ">
                                        <div className="position-relative">
                                          <SearchBar
                                            {...toolkitprops.searchProps}
                                          />
                                          <i className="bx bx-search-alt search-icon" />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col md="4">
                                      <AvForm
                                        className="d-flex "
                                        id="filter-date-form"
                                        onValidSubmit={
                                          this.handleFilterDataSubmit
                                        }
                                        onReset={this.handleFormReset}
                                      >
                                        <FormGroup className="me-1">
                                          <AvField
                                            type="select"
                                            name="month"
                                            className="form-select"
                                            onChange={this.handleFilterChange}
                                            value={filteredMonth}
                                          >
                                            {/* {actShippings.length != 0 &&
                                              this.getDate(actShippings, 'month')
                                                .sort(function (a, b) {
                                                  return a - b;
                                                })
                                                .map((month, index) => (
                                                  <option value={month} key={index} className='fw-bold fs-5'>
                                                    {months[month - 1]}
                                                  </option>
                                                ))} */}
                                            {[
                                              ...new Set(
                                                actShippings.map(
                                                  (item) => item.month,
                                                ),
                                              ),
                                            ].map((month, index) => (
                                              <option
                                                value={month}
                                                key={index}
                                                className="fw-bold fs-5"
                                              >
                                                {months[month - 1]}
                                              </option>
                                            ))}
                                          </AvField>
                                        </FormGroup>
                                        <FormGroup className="me-1">
                                          <AvField
                                            type="select"
                                            name="year"
                                            className="form-select"
                                            value={filteredYear}
                                          >
                                            {actShippings.length !== 0 &&
                                              this.getDate(actShippings, "year")
                                                .sort(function (a, b) {
                                                  return a - b;
                                                })
                                                .map((year, index) => (
                                                  <option
                                                    value={year}
                                                    key={index}
                                                    className="fw-bold fs-5"
                                                  >
                                                    {year}
                                                  </option>
                                                ))}
                                          </AvField>
                                        </FormGroup>
                                        <FormGroup className="me-1">
                                          <button
                                            className="btn btn-success save-user"
                                            id="dblclick"
                                          >
                                            Filter
                                          </button>
                                        </FormGroup>
                                        <FormGroup className="">
                                          <button
                                            type="reset"
                                            className="btn btn-primary save-user"
                                          >
                                            Resets
                                          </button>
                                        </FormGroup>
                                      </AvForm>
                                    </Col>
                                    <Col md="2">
                                      <div className="text-sm-end">
                                        <MyExportCSV
                                          {...toolkitprops.csvProps}
                                        />
                                      </div>
                                    </Col>
                                    <Col md="4" sm="12">
                                      <div className="text-sm-end">
                                        <Button
                                          color="success"
                                          id="exportPDF"
                                          className="font-16 btn-block btn btn-primary btn-lg me-2"
                                          onClick={this.handleExportPDF}
                                          disabled={
                                            selectedRows.length === 0
                                              ? true
                                              : false
                                          }
                                        >
                                          <i className="mdi mdi-plus-circle-outline me-1" />
                                          Export PDF
                                        </Button>
                                        <Button
                                          color="primary"
                                          className="font-16 btn-block btn btn-primary btn-lg"
                                          onClick={
                                            this.handleNewActShippingClick
                                          }
                                        >
                                          <i className="mdi mdi-plus-circle-outline me-1" />
                                          Add Order
                                        </Button>
                                        <Modal
                                          size="lg"
                                          autoFocus={false}
                                          isOpen={
                                            this.state.modalNewActShipping
                                          }
                                          className={this.props.className}
                                          toggle={
                                            this.toggleNewActShippingModal
                                          }
                                        >
                                          <ModalHeader
                                            toggle={
                                              this.toggleNewActShippingModal
                                            }
                                            tag="h4"
                                          >
                                            {!!isEdit
                                              ? "Edit Order"
                                              : "Add Order"}
                                          </ModalHeader>
                                          <ModalBody>
                                            {error !== "" && error ? (
                                              <Alert color="danger">
                                                {error}{" "}
                                              </Alert>
                                            ) : null}
                                            <AvForm
                                              onValidSubmit={
                                                this.handleNewActShippingSubmit
                                              }
                                            >
                                              <Row>
                                                <Col md={4}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="invoiceNo"
                                                      label="Invoice №"
                                                      type="text"
                                                      autoComplete="off"
                                                      value={
                                                        actShipping.invoiceNo ||
                                                        ""
                                                      }
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col md={2}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="quantity"
                                                      label="Quantity"
                                                      type="text"
                                                      autoComplete="off"
                                                      value={
                                                        actShipping.quantity ||
                                                        ""
                                                      }
                                                      onChange={
                                                        this.handleDateCopy
                                                      }
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col md={2}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="brochures"
                                                      label="Brochures"
                                                      type="text"
                                                      autoComplete="off"
                                                      value={
                                                        Math.floor(
                                                          this.state.brochures,
                                                        ) || ""
                                                      }
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col md={4}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="country"
                                                      label="Country"
                                                      type="text"
                                                      autoComplete="off"
                                                      value={
                                                        actShipping.country ||
                                                        ""
                                                      }
                                                    />
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col md={4}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="city"
                                                      label="City"
                                                      type="text"
                                                      autoComplete="off"
                                                      value={
                                                        actShipping.city || ""
                                                      }
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col md={4}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="region"
                                                      label="Region"
                                                      type="text"
                                                      autoComplete="off"
                                                      value={
                                                        actShipping.region || ""
                                                      }
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col md={4}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="name"
                                                      label="Name"
                                                      type="text"
                                                      autoComplete="off"
                                                      value={
                                                        actShipping.name || ""
                                                      }
                                                    />
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col md={12}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="comments"
                                                      label="Comments"
                                                      autoComplete="off"
                                                      className="font-size-20"
                                                      type="textarea"
                                                      rows="1"
                                                      value={
                                                        actShipping.comments ||
                                                        ""
                                                      }
                                                    />
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col md={12}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="address"
                                                      label="Address"
                                                      autoComplete="off"
                                                      className="font-size-20"
                                                      type="textarea"
                                                      rows="2"
                                                      value={
                                                        actShipping.address ||
                                                        ""
                                                      }
                                                    />
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col md={4}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="phone"
                                                      label="Phone"
                                                      type="text"
                                                      placeholder="+1-(555)-555-5555"
                                                      errorMessage="Invalid Number"
                                                      validate={{
                                                        required: {
                                                          value: true,
                                                        },
                                                      }}
                                                      value={
                                                        actShipping.phone || ""
                                                      }
                                                    />
                                                  </FormGroup>
                                                </Col>

                                                <Col md={4}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="month"
                                                      label="Month"
                                                      type="text"
                                                      autoComplete="off"
                                                      disabled
                                                      value={month || ""}
                                                    />
                                                  </FormGroup>
                                                </Col>

                                                <Col md={4}>
                                                  <FormGroup className="mb-3">
                                                    <AvField
                                                      name="year"
                                                      label="Year"
                                                      type="text"
                                                      autoComplete="off"
                                                      disabled
                                                      value={year || ""}
                                                    />
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col>
                                                  <div className="text-end">
                                                    {loading && <BtnLoader />}
                                                    <button
                                                      className="btn btn-success save-user"
                                                      disabled={
                                                        !correctDate ||
                                                        (loading && true)
                                                      }
                                                    >
                                                      {!!isEdit
                                                        ? "Edit Order"
                                                        : "Add Order"}
                                                    </button>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </AvForm>
                                          </ModalBody>
                                        </Modal>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row id="table-section">
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap"
                                      }
                                      headerClasses="header-class is-sticky-hdr"
                                      id="tableScroll"
                                      filter={filterFactory()}
                                      rowClasses={this.rowClasses}
                                      selectRow={selectRow}
                                      noDataIndication={this.indication}
                                      // hiddenRows={this.hiddenRowKeys()}
                                      responsive
                                      cellEdit={cellEditFactory({
                                        mode: "click",
                                        blurToSave: true,
                                        afterSaveCell: this.afterSaveCell,
                                      })}
                                    />

                                    <Col className="inner-custom-pagination d-flex mt-1">
                                      <div className="d-inline">
                                        <SizePerPageDropdownStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                      <div className="text-md-right ms-auto pagination pagination-rounded justify-content-end mb-2">
                                        <PaginationListStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  {this.state.alert}
                                </React.Fragment>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            ) : (
              <Alert color="danger">
                {" "}
                You do not have access to this page.{" "}
              </Alert>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ActShippingList.propTypes = {
  actShippings: PropTypes.array,
  onGetActShipping: PropTypes.func,
  onAddActShipping: PropTypes.func,
  onUpdateActShipping: PropTypes.func,
  onDeleteActShipping: PropTypes.func,
};

const mapStateToProps = ({ actShipping }) => ({
  actShippings: actShipping.actShippings,
  loading: actShipping.loading,
});

const mapDispatchToProps = (dispatch) => ({
  onGetActShipping: () => dispatch(getActShippings()),
  onAddActShipping: (actShipping) => dispatch(addActShipping(actShipping)),
  onUpdateActShipping: (actShipping) =>
    dispatch(updateActShipping(actShipping)),
  onDeleteActShipping: (actShipping) =>
    dispatch(deleteActShipping(actShipping)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ActShippingList));
